<div class="row content-container">
  @if (claim) {
    <div
      class="col-12 col-sm-12 main-content mynovi mynovi--claim-detail"
      >
      <div class="button-bar button-bar--justify">
        <a [routerLink]="['/my/claims']">
          <strong>
            <svg class="icon-arrow-left" height="10" width="6">
              <use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
            </svg>
            <span i18n="@@claims.detail.back.to.overview">
            Back to claim list
          </span>
          </strong>
        </a>
      </div>
      <!-- <span>'s binnen de h1 zorgen ervoor dat de datum en locatie los van elkaar op een nieuwe regel breken als het scherm kleiner wordt -->
      <h1 class="claim-detail-title">
        <span i18n="@@new.claims.overview.claim">Claim</span>
        @if (claim.claimId) {
          <span>{{ claim.claimId }}</span>
        }
      </h1>
      <p class="claim-detail-intro">
        <span i18n="@@claims.detail.accountmanager.text">
        View the details of this claim here. Any questions? Contact your account
        manager.
      </span>
      </p>
      <div class="claim-detail-info claim-detail-info--top">
        <dl>
          <dt i18n="@@claims.date">Date of claim</dt>
          @if (claim.creationDate) {
            <dd>
              {{ claim.creationDate | customDate: "EEEE dd MMMM YYYY" }}
            </dd>
          }
        </dl>
        <dl>
          <dt i18n="@@claims.status">Status</dt>
          <span [status]="claim.status" render-claim-status></span>
        </dl>
        @if (claim.solutionText) {
          <dl>
            <dt class="claim-detail-info__title"></dt>
            <span>{{ claim.solutionText }}</span>
          </dl>
        }
      </div>
      <table class="claim-detail-table">
        <thead>
          <tr>
            <th i18n="@@claims.detail.table.header.order" scope="col">Order</th>
            <th></th>
            <th i18n="@@new.claims.overview.article" scope="col">Article</th>
            <th i18n="@@order.amount" scope="col">Amount & unit</th>
            <th i18n="@@order.potsize" scope="col">Pot size</th>
            <th i18n="@@order.height" scope="col">Height</th>
            <th i18n="@@order.volume" scope="col">Volume</th>
            <th i18n="@@order.price" scope="col">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="claim-detail-table_order_info">
              <p>{{ claim.orderId }}</p>
              <p>{{ claim.shipmentDate | customDate: "dd MMMM YYYY" }}</p>
            </td>
            <td
              [description]="claim.itemDescription"
              [imageFormat]="80"
              [image]="getImage(claim.image)"
              class="claim-detail-table_image"
              render-product-image
            ></td>
            <td class="claim-detail-table_product">
              {{ claim.itemDescription }}
            </td>
            <td class="claim-detail-table_amount">
              <span i18n="@@shoppingcart.amount.tray">
              {{ claim.boxQuantity }} x {{ claim.quantityPerBox }}
            </span>
            </td>
            <td class="claim-detail-table_potsize">
              <div class="claim-detail-table_icon-text">
                <svg
                  class="icon-potsize"
                  height="11"
                  viewBox="0 0 16 11"
                  width="16"
                  >
                  <use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
                </svg>
                <span>{{ claim.potWidth || "-" }}</span>
              </div>
            </td>
            <td class="claim-detail-table_height">
              <div class="claim-detail-table_icon-text">
                <svg
                  class="icon-potheight"
                  height="11"
                  viewBox="0 0 6 11"
                  width="6"
                  >
                  <use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
                </svg>
                <span>{{ claim.potHeight || "-" }}</span>
              </div>
            </td>
            <td class="claim-detail-table_volume">
              <span i18n="@@calculated.volume"
                >{{ claim.volume | numberFormat: false }} CC</span
                >
              </td>
              <td class="claim-detail-table_price">
                {{ applicationService.getUserCurrency() }}
                {{ claim.price | numberFormat: true }}
              </td>
            </tr>
          </tbody>
        </table>
        @if (getDetails()) {
          <div class="claim-detail-info">
            <dl>
              <dt i18n="@@claims.detail.header">Reclamation details</dt>
              <dd>{{ getDetails() }}</dd>
            </dl>
          </div>
        }
        @if (claim.description) {
          <div class="claim-detail-info">
            <dl class="claims-detail--comment">
              <dt i18n="@@claims.detail.comments">Comments</dt>
              <dd>{{ claim.description }}</dd>
            </dl>
          </div>
        }
        @if (claimHasImages()) {
          <div class="claim-detail-info">
            <dl class="claims-detail--images">
              <dt i18n="@@claims.detail.photos">Photos</dt>
              <dd>
                @for (image of images; track image) {
                  <a (click)="openImageInPopup(image)">
                    <img [alt]="claimId" [src]="getImageForClaimUrl(image)" />
                  </a>
                }
              </dd>
            </dl>
          </div>
        }
      </div>
    }
  </div>
